// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const RefreshIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Refresh",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2.92 13.11h7.36s.1.01.15.01c.55 0 .99-.44.99-.99 0-.34-.17-.63-.42-.81S8.87 9.17 8.87 9.17c1.86-2.08 4.54-3.38 7.54-3.38.32 0 .65.01.96.05h-.04c3.89.48 7.16 3.54 8.54 7.99a2.031 2.031 0 0 0 3.97-.6c0-.21-.03-.42-.09-.61-1.87-5.97-6.43-10.11-11.88-10.79-.44-.05-.95-.08-1.46-.08-4.1 0-7.79 1.76-10.36 4.56S3.69 3.96 3.69 3.96c-.19-.19-.45-.3-.73-.3-.57 0-1.04.46-1.04 1.03v7.37c0 .57.46 1.03 1.03 1.04Zm25.89 5.77h-7.37s-.1-.01-.15-.01c-.55 0-.99.44-.99.99 0 .34.17.63.42.81s2.14 2.14 2.14 2.14a10.08 10.08 0 0 1-7.54 3.38c-.32 0-.64-.01-.95-.04h.04c-3.89-.48-7.16-3.54-8.54-7.99a2.031 2.031 0 0 0-3.97.6c0 .21.03.42.09.61 1.84 5.93 6.4 10.11 11.88 10.79.48.06 1.03.1 1.58.1 4.07-.06 7.72-1.8 10.29-4.57s2.35 2.34 2.35 2.34c.19.19.45.3.73.3.57 0 1.04-.46 1.04-1.03v-7.37c0-.57-.47-1.04-1.04-1.04h-.04Z"
    })
  });
};